import { WeighmentSitesAPI } from "api";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const BasicInformation = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const navigate = useNavigate();
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const [sites, setSites] = useState([]);
  const maxCharactersLength = 255;

  useEffect(() => {
    const fetchSite = async () => {
      try {
        setLoading(true);
        const response = await WeighmentSitesAPI.get();
        setSites(response?.data?.data);
      } catch (error) {
        console.log(error);
      }
      setLoading(false);
    };
    fetchSite();
  }, []);

  console.log(sites);

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Code"
                  title="Code"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.code}
                  {...register("code")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.code?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Name"
                  title="Name"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.name}
                  {...register("name")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.name?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="site"
                  type="text"
                  title="Site"
                  className="py-2"
                  isInvalid={!!errors?.siteId}
                  {...register("siteId")}
                >
                  <option value="">Select Site</option>
                  {sites?.map((d) => (
                    <option key={d.id} value={d.id}>
                      {d.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.siteId?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Card.Header as="h6" className="bg-body-tertiary mb-2 mt-2 mx-1">
              Settings
            </Card.Header>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Port"
                  title="Port"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.portName}
                  {...register("portName")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.portName?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="baudRate"
                  type="text"
                  title="Baud Rate"
                  className="py-2"
                  isInvalid={!!errors?.baudRate}
                  {...register("baudRate")}
                >
                  <option value="">Select Baud Rate</option>
                  {[
                    75, 110, 300, 1200, 2400, 4800, 9600, 19200, 38400, 57600,
                    115200,
                  ].map((d, index) => (
                    <option key={index} value={d}>
                      {d}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.baudRate?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="dataBits"
                  type="text"
                  title="Data Bits"
                  className="py-2 mb-1"
                  isInvalid={!!errors?.dataBits}
                  {...register("dataBits")}
                >
                  <option value="">Select Data Bits</option>
                  {[5, 6, 7, 8].map((d, index) => (
                    <option key={index} value={d}>
                      {d}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.dataBits?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="parity"
                  type="text"
                  title="Parity"
                  className="py-2 mb-1"
                  isInvalid={!!errors?.parity}
                  {...register("parity")}
                >
                  <option value="">Select Parity</option>
                  {["None", "Odd", "Even", "Mark", "Space"].map((d, index) => (
                    <option key={index} value={d}>
                      {d}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.parity?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="stopBit"
                  type="text"
                  title="Stop Bit"
                  className="py-2"
                  isInvalid={!!errors?.stopBit}
                  {...register("stopBit")}
                >
                  <option value="">Select Stop Bit</option>
                  {[1, 2].map((d, index) => (
                    <option key={index} value={d}>
                      {d}
                    </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.parity?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default BasicInformation;
